import find from 'lodash/find';
import get from 'lodash/get';

export default function hasFreeTrial(productSkuToCheck, subscribeProducts) {
  if (!productSkuToCheck || !subscribeProducts || !subscribeProducts.length) {
    return false;
  }

  // filter out the products to see if there's one with a trial
  return (
    find(
      subscribeProducts,
      (product) =>
        get(product, 'sku').match(productSkuToCheck) &&
        get(product, 'freeTrialLength') !== '0',
    ) || false
  );
}
